export const saveRequirementProgress = (
  folderId: string,
  requirementId: string,
  values: object,
): void => {
  localStorage.setItem(
    `requirementProgress-${folderId}-${requirementId}`,
    JSON.stringify(values),
  );
};

export const removeRequirementProgress = (
  folderId: string,
  requirementId: string,
): void => {
  localStorage.removeItem(`requirementProgress-${folderId}-${requirementId}`);
};

export const getRequirementProgress = (
  folderId: string,
  requirementId: string,
): object => {
  const progress = localStorage.getItem(
    `requirementProgress-${folderId}-${requirementId}`,
  );
  return progress ? JSON.parse(progress) : {};
};
